module.exports = __webpack_public_path__ + "media/images/arrow-5e1430e4126b28522d4923e729bdd0d6.svg";